const fragment = `
  id
  imageUrl
  isDefault
`;

export const listPaletteImagesQuery = `
  query ListPaletteImages(
    $filter: PaletteImageFilterInput
  ) {
    items: listPaletteImages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createPaletteImageQuery = `
  mutation CreatePaletteImage(
    $input: CreatePaletteImageInput!
    $image: Upload
  ) {
    item: createPaletteImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updatePaletteImageQuery = `
  mutation UpdatePaletteImage(
    $input: UpdatePaletteImageInput!
    $image: Upload
  ) {
    item: updatePaletteImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deletePaletteImageQuery = `
  mutation DeletePaletteImage(
    $id: Int!
  ) {
    item: deletePaletteImage(id: $id) {
      ${fragment}
    }
  }
`;

export const sortPaletteImagesQuery = `
  mutation SortPaletteImages(
    $paletteId: Int!,
    $ids: [Int!]!
  ) {
    items: sortPaletteImages(paletteId: $paletteId, ids: $ids) {
      id
    }
  }
`;
